import React from "react";

export default function Logo({ className, onlyIcon = false }) {
    if (onlyIcon) {
        // Show only the "A" character
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 68.8 68.8"
                className={className}
            >
                <g fill="currentColor" id="Layer_2" data-name="Layer 2">
                    <g fill="currentColor" id="Layer_1-2" data-name="Layer 1">
                        <polygon
                            fill="currentColor"
                            className="cls-1"
                            points="68.8 10.07 58.72 0 0 27.69 9.09 36.78 53.71 15.02 31.96 59.65 41.1 68.8 68.8 10.07"
                        />
                        <path
                            fill="currentColor"
                            className="cls-1"
                            d="M24.87,52.58l-8.36,8.36L7.86,52.29l8.35-8.36Z"
                        />
                    </g>
                </g>
            </svg>
        );
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 359.97 66.75"
            className={className}
        >
            <g id="Layer_2" data-name="Layer 2" fill="currentColor">
                <g id="Layer_1-2" data-name="Layer 1" fill="currentColor">
                    <path
                        fill="currentColor"
                        d="M293.52.71V34.94c0,3.76,1,6.62,2.93,8.6s4.7,3,8.24,3,6.37-1,8.32-3,2.93-4.84,2.93-8.6V.71h11.18V34.87a22.07,22.07,0,0,1-3.05,11.92,19.4,19.4,0,0,1-8.17,7.33,25.83,25.83,0,0,1-11.37,2.46,25.19,25.19,0,0,1-11.21-2.46,18.7,18.7,0,0,1-8-7.33,22.68,22.68,0,0,1-2.93-11.92V.71Z"
                    />
                    <path
                        fill="currentColor"
                        d="M348.91,11.42V56h-11.1V11.42Z"
                    />
                    <path fill="currentColor" d="M360,.71V11.42H348.88V.71Z" />
                    <path
                        fill="currentColor"
                        d="M95.26,17.35A13,13,0,0,0,90,12a15.92,15.92,0,0,0-7.76-1.82,17,17,0,0,0-8.72,2.22,15.37,15.37,0,0,0-5.94,6.34,20.32,20.32,0,0,0-2.14,9.51A20.44,20.44,0,0,0,67.65,38a15.36,15.36,0,0,0,6.06,6.33,17.88,17.88,0,0,0,9,2.22,15.72,15.72,0,0,0,10.39-3.36,16.09,16.09,0,0,0,5.3-9.39h-19V25.28h30v9.66a26,26,0,0,1-4.76,10.7,26.8,26.8,0,0,1-9.39,7.89,27.61,27.61,0,0,1-12.87,3,29.06,29.06,0,0,1-14.46-3.61,26.2,26.2,0,0,1-10.15-10,28.82,28.82,0,0,1-3.68-14.58,29,29,0,0,1,3.68-14.62A26.1,26.1,0,0,1,67.89,3.61,28.92,28.92,0,0,1,82.27,0,28.74,28.74,0,0,1,98.51,4.56,23.2,23.2,0,0,1,108,17.35Z"
                    />
                    <path
                        fill="currentColor"
                        d="M128.7,9.67V23.53h18.62v8.8H128.7V47h21v9H117.61V.63H149.7v9Z"
                    />
                    <path
                        fill="currentColor"
                        d="M207.07,56H196L170.86,18.07V56h-11.1V.63h11.1l25.12,38V.63h11.09Z"
                    />
                    <path
                        fill="currentColor"
                        d="M255.64.71v9H240.91V56h-11.1V9.67H215.07v-9Z"
                    />
                    <polygon
                        fill="currentColor"
                        points="32.8 0.63 19.89 0.63 0 56.02 11.65 56.02 26.31 13.47 40.97 56.02 52.69 56.02 32.8 0.63"
                    />
                    <path fill="currentColor" d="M31.89,56V66.75H20.8V56Z" />
                </g>
            </g>
        </svg>
    );
}
